import React, { InputHTMLAttributes, useState } from 'react';
import styles from './Checkbox.module.css';

interface CheckboxProps {
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  children?: React.ReactNode;
  style?: React.CSSProperties; // React.CSSProperties 타입의 style 속성 추가
}
function Checkbox({
  checked,
  onChange,
  children,
  style,
  ...rest
}: CheckboxProps & React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className={styles.checkboxLabel}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={styles.checkboxInput}
        {...rest}
      />
      <span
        className={styles.checkboxCustom}
        style={{
          ...style,
        }}
      ></span>
      {children && <span className={styles.checkboxText}>{children}</span>}
    </label>
  );
}

export default Checkbox;
